import { render, staticRenderFns } from "./IconOnboard.vue?vue&type=template&id=ae49d916"
import script from "./IconOnboard.vue?vue&type=script&lang=js"
export * from "./IconOnboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports